<template>
  <div
      :style="{ gridTemplateColumns: 'repeat(' + columns + ', minmax(0, 1fr))' }"
      class="effect-tiles">
    <button
        v-for="option in options"
        :key="option.value"
        :aria-pressed="value === option.value ? 'true' : 'false'"
        :class="{ 'is-on': value === option.value }"
        type="button"
        class="effect-tile"
        @click="$emit('select', option.value)">
      <span class="effect-tile__preview">
        <span
            v-if="option.preview === 'none'"
            class="effect-tile__none">
          <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.6"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true">
            <circle
                cx="12"
                cy="12"
                r="8"/>
            <path d="M6.5 17.5l11-11"/>
          </svg>
        </span>
        <span
            v-else-if="option.preview === 'outline'"
            class="effect-tile__mark effect-tile__mark--outline"/>
        <span
            v-else-if="option.preview === 'shadow'"
            class="effect-tile__mark effect-tile__mark--shadow"/>
        <span
            v-else-if="option.preview === 'blur'"
            class="effect-tile__mark effect-tile__mark--blur"/>
      </span>
      <span class="effect-tile__label">{{ option.label }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name:  'EffectTiles',
  props: {
    options: { type: Array, required: true },
    value:   { type: String, default: 'none' },
    columns: { type: Number, default: 4 },
  },
};
</script>

<style lang="scss" scoped>
.effect-tiles {
  display: grid;
  gap: 6px;
}

.effect-tile {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  padding: 5px 5px 7px;
  border: 0;
  border-radius: 10px;
  background: #fff;
  box-shadow: inset 0 0 0 1px #e7e9ed;
  color: #3d4350;
  font-family: inherit;
  cursor: pointer;

  &.is-on {
    background: #eaf2fe;
    box-shadow: inset 0 0 0 1.5px #1570ef;
    color: #0b57c2;

    .effect-tile__preview {
      background: #fff;
    }

    .effect-tile__label {
      font-weight: 600;
    }
  }
}

.effect-tile__preview {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  border-radius: 7px;
  background: #f3f4f6;
  color: #3d4350;
}

.effect-tile__none {
  display: flex;
  color: #5e6573;

  svg {
    display: block;
    flex-shrink: 0;
  }
}

.effect-tile__mark {
  display: block;
  border-radius: 4px;
  background: #9db2e8;
}

.effect-tile__mark--outline,
.effect-tile__mark--shadow {
  width: 18px;
  height: 18px;
}

.effect-tile__mark--outline {
  box-shadow: 0 0 0 2px #14161b;
}

.effect-tile__mark--shadow {
  box-shadow: 3px 3px 4px rgba(20, 22, 27, 0.45);
}

.effect-tile__mark--blur {
  width: 16px;
  height: 16px;
  box-shadow: 0 0 5px 3px #9db2e8;
}

.effect-tile__label {
  font-size: 11.5px;
  font-weight: 500;
  line-height: 1.2;
  text-align: center;
}
</style>
